import data from "../../data/index.json";
import {Laptop} from 'react-bootstrap-icons';

export default function MySkills() {
  return (
    <section className="skills--section" id="mySkills">
      <div className="portfolio--container">
        <p className="section--title">My Skills</p>
        <h2 className="skills--section--heading">My Expertise</h2>
      </div>
      <div className="skills--section--container">
        
        
          <div className="skills--section--card">
            <div className="skills--section--img">
              <img className ="skill-icon" src="./img/frontend.png" alt="icon" />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">
                Reactjs - Javascript
              </h3>
              <p className="skills--section--description">I have got plenty of experience designing the pages using html, css, javascript and react.</p>  
              <div className="skillset--icons">
                <img src="https://seeklogo.com/images/H/html5-without-wordmark-color-logo-14D252D878-seeklogo.com.png" alt="icon" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png" alt="icon" />
                <img src="https://ww1.freelogovectors.net/wp-content/uploads/2019/02/sass-logo.png?lossy=1&w=2560&ssl=1" alt="icon" />
                <img src="https://seeklogo.com/images/J/javascript-logo-8892AEFCAC-seeklogo.com.png" alt="icon" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png" alt="icon" />
              </div>
            </div>
          </div>

          <div  className="skills--section--card">
            <div className="skills--section--img">
              <img className ="skill-icon" src="./img/backend.png" alt="icon" />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">Django - Python</h3>
              <p className="skills--section--description">I have got necessary experience of developing backend with django backend APIs with django rest framework to interact with external sources.</p>
              <div className="skillset--icons">
                <img src="https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png" alt="icon" />
                <img src="https://seeklogo.com/images/D/django-logo-4C5ECF7036-seeklogo.com.png" alt="icon" />
                <img src="https://www.svgrepo.com/show/354113/nextjs-icon.svg" alt="icon" />
                <img src="https://1000logos.net/wp-content/uploads/2020/08/MySQL-Logo.png" alt="icon" />
              </div>
            </div>
          </div>

          <div className="skills--section--card">
            <div className="skills--section--img">
              <img className ="skill-icon" src="https://cdn-icons-png.flaticon.com/512/4824/4824797.png" alt="icon" />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">Data Analytics</h3>
              <p className="skills--section--description">I am a Entry-Level Data Analyst who is keep to contribute to a cause. I am young, energetic, and geeky individual whose desire to learn is endless.</p>
              <div className="skillset--icons">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/1869px-Python-logo-notext.svg.png" alt="icon" />
                
                <img src="https://upload.wikimedia.org/wikipedia/commons/7/7c/Kaggle_logo.png" alt="icon" />
               
              </div>
            </div>
          </div> 

      
        
      </div>
    </section>
  );
}
